<template>
  <b-modal
    id="chantier-projet-form-modal"
    :title="isEdit ? 'Modifier le projet' : 'Nouveau projet d\'amélioration continue'"
    :ok-title="isEdit ? 'Enregistrer' : 'Créer'"
    cancel-title="Annuler"
    cancel-variant="outline-secondary"
    :ok-disabled="saving"
    centered
    @ok.prevent="submit"
  >
    <b-form-group
      label="Nom du projet"
      label-for="projet-nom"
    >
      <b-form-input
        id="projet-nom"
        v-model="model.nom"
        placeholder="Ex. Amélioration du parcours adhérent"
      />
    </b-form-group>
    <b-form-group
      label="Description (optionnel)"
      label-for="projet-description"
    >
      <b-form-textarea
        id="projet-description"
        v-model="model.description"
        rows="3"
      />
    </b-form-group>
    <p
      v-if="error"
      class="text-danger mb-0"
    >
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'ChantierProjetFormModal',
  components: {
    BModal, BFormGroup, BFormInput, BFormTextarea,
  },
  data() {
    return {
      editId: null,
      model: { nom: '', description: '' },
      saving: false,
      error: null,
    }
  },
  computed: {
    isEdit() { return !!this.editId },
  },
  methods: {
    // Ouvre la modale. projet fourni => édition ; sinon => création.
    open(projet) {
      this.error = null
      this.saving = false
      if (projet) {
        this.editId = projet.id
        this.model = { nom: projet.nom || '', description: projet.description || '' }
      } else {
        this.editId = null
        this.model = { nom: '', description: '' }
      }
      this.$bvModal.show('chantier-projet-form-modal')
    },
    async submit() {
      if (!this.model.nom || !this.model.nom.trim()) {
        this.error = 'Le nom est obligatoire.'
        return
      }
      if (this.saving) return
      this.saving = true
      this.error = null
      try {
        const payload = {
          nom: this.model.nom.trim(),
          description: this.model.description || undefined,
        }
        let id = this.editId
        if (this.isEdit) {
          await this.$http.myressif.chantierProjets.update(this.editId, payload)
        } else {
          id = await this.$http.myressif.chantierProjets.create(payload)
        }
        this.$bvModal.hide('chantier-projet-form-modal')
        this.$emit('saved', id)
      } catch (e) {
        this.error = "L'enregistrement du projet a échoué."
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
